import React, { useState } from 'react'
import './login.css'
import { useNavigate } from 'react-router-dom'
import { toast } from 'wc-toast'
import { useAuthContext } from '../../Hooks/useAuthContext'

function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [btn, setBtnState]      = useState('Login')
  const { dispatch }            = useAuthContext()
  const navigate                = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setBtnState('Processing...')
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/login-admin`, {
      method:  'POST',
      headers: { 'content-type': 'application/json' },
      body:    JSON.stringify({ username, password }),
    })
    const json = await response.json()
    if (!response.ok) {
      toast.error(json.error)
      setBtnState('Login')
    }
    if (response.ok) {
      localStorage.setItem('user', JSON.stringify(json))
      dispatch({ type: 'LOGIN', payload: json })
      navigate('/admin-panel')
    }
  }

  return (
    <div className="adm-login">

      {/* Left decorative panel */}
      <div className="adm-login__panel">
        <div className="adm-login__panel-inner">
          <div className="adm-login__brand">
            <span className="adm-login__brand-dot" />
            {process.env.REACT_APP_APP_NAME}
          </div>
          <h2 className="adm-login__tagline">Secure Admin<br />Control Centre</h2>
          <p className="adm-login__sub">Authorised personnel only. All activity is monitored and logged.</p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="adm-login__form-wrap">
        <form className="adm-login__form" onSubmit={handleSubmit}>

          {/* Lock icon */}
          <div className="adm-login__icon">
            <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <rect x="3" y="11" width="18" height="11" rx="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>

          <p className="adm-login__eyebrow">Admin Portal</p>
          <h1 className="adm-login__title">Sign in</h1>

          <div className="adm-login__field">
            <label htmlFor="adm-username">Username</label>
            <div className="adm-login__input-wrap">
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
              </svg>
              <input
                id="adm-username"
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
          </div>

          <div className="adm-login__field">
            <label htmlFor="adm-password">Password</label>
            <div className="adm-login__input-wrap">
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input
                id="adm-password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
          </div>

          <button
            type="submit"
            className="adm-login__btn"
            disabled={btn === 'Processing...'}
          >
            {btn === 'Processing...' ? (
              <>
                <span className="adm-login__spinner" />
                Authenticating…
              </>
            ) : (
              <>Sign in →</>
            )}
          </button>

          <p className="adm-login__note">
            <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r=".5" fill="currentColor"/>
            </svg>
            Protected area. Unauthorised access is prohibited.
          </p>

        </form>
      </div>

    </div>
  )
}

export default Login